(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4987],{

/***/ 62328:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-drive",
      function () {
        return __webpack_require__(82326);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ test_drive; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/components/form/baseInputs/index.ts + 17 modules
var baseInputs = __webpack_require__(68113);
// EXTERNAL MODULE: ./src/components/form/fields/index.ts + 88 modules
var fields = __webpack_require__(68143);
// EXTERNAL MODULE: ./src/components/form/layout/index.ts + 2 modules
var layout = __webpack_require__(76817);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 7 modules
var ui = __webpack_require__(20388);
// EXTERNAL MODULE: ./src/contexts/index.tsx + 96 modules
var contexts = __webpack_require__(28798);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(97859);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(67958);
// EXTERNAL MODULE: ./src/utils/helpers/index.ts + 9 modules
var helpers = __webpack_require__(45911);
// EXTERNAL MODULE: ./src/utils/helpers/tracking.ts + 1 modules
var helpers_tracking = __webpack_require__(68379);
// EXTERNAL MODULE: ./src/utils/schemas/index.ts + 45 modules
var schemas = __webpack_require__(73705);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(46392);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(34376);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(75367);
;// CONCATENATED MODULE: ./src/assets/icons/ev.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgEv = function SvgEv(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 64,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3 13.93h-.01c.45.38.71.94.71 1.53V20c0 1.1-.9 2-2 2h-6.06c-.49 3.95-3.86 7-7.94 7s-7.45-3.05-7.94-7H19.94c-.49 3.95-3.82 7-7.94 7-4.12 0-7.51-3.12-7.95-7.13a7.12 7.12 0 0 1-3.48-1.88c-.39-.39-.57-.9-.57-1.38V9.35c0-.76.44-1.43 1.07-1.78 1.22-.68 2.74-1.76 3.95-3C5.88 3.68 6.5 2.8 6.8 2H4.01c-.55 0-1-.45-1-1s.45-1 1-1h34.4c.26 0 .52.04.77.15 2.14.9 5.87 3.04 11.68 6.94 3.39 1.2 5.66 2.19 7.51 3.25 1.86 1.06 3.27 2.17 4.93 3.59ZM6.01 20.98c0 3.31 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6-6 2.69-6 6Zm36 0c0 3.31 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6-6 2.69-6 6Zm13.94-1H62v-4.52c-1.63-1.38-2.93-2.4-4.63-3.37-1.71-.98-3.85-1.92-7.19-3.11-.16-.06-.31-.14-.45-.23-5.79-3.89-9.38-5.93-11.34-6.76H8.88c-.34 1.47-1.34 2.84-2.43 3.96C5.09 7.35 3.4 8.54 2.04 9.3c-.02.01-.03.03-.03.03v9.25A5.2 5.2 0 0 0 4.1 19.8c.57-3.86 3.83-6.82 7.91-6.82s7.45 3.05 7.94 7h20.12c.49-3.95 3.86-7 7.94-7s7.45 3.05 7.94 7ZM32.53 8.96h.35l.01.01c1.43 0 2.28 1.59 1.49 2.78l-3.68 5.52c-1.08 1.63-3.62.58-3.24-1.34l.58-2.94h-.24c-1.41 0-2.27-1.56-1.51-2.75l3.44-5.4c1.05-1.64 3.59-.67 3.27 1.25l-.47 2.87Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var ev = (SvgEv);
;// CONCATENATED MODULE: ./src/pages/test-drive.tsx
/* eslint-disable @next/next/no-img-element */ 















const TestDrive = (param)=>{
    let { models , content , tracking , brand , dealer , model , query  } = param;
    var ref;
    const { push , query: routerQuery  } = (0,router.useRouter)();
    const clientDealer = (0,contexts/* useDealer */.qY)();
    const campaign = (0,contexts/* useCampaign */.yQ)();
    const [formStep, setFormStep] = (0,react.useState)(1);
    const [isVehicleExpanded, expandVehicle] = (0,react.useState)(false);
    const [isDealerExpanded, expandDealer] = (0,react.useState)(false);
    const [isDetailsExpanded, expandDetails] = (0,react.useState)(false);
    const [formData, setFormData] = (0,react.useState)({});
    const [submitResponse, setSubmitResponse] = (0,react.useState)("");
    const [user, setUser] = (0,react.useState)(false);
    const [selectedDealer, setSelectedDealer] = (0,react.useState)({});
    if (clientDealer) {
        // eslint-disable-next-line no-param-reassign
        dealer = clientDealer;
    }
    const step = (newFormStep, userState)=>{
        setUser(userState);
        setFormStep(newFormStep);
    };
    const configID = (ref = (query === null || query === void 0 ? void 0 : query.configId) || (query === null || query === void 0 ? void 0 : query.code)) === null || ref === void 0 ? void 0 : ref.replace(/[^a-zA-Z0-9]/g, "");
    const initialValues = {
        first_name: "",
        last_name: "",
        email: "",
        tel: "",
        model: "",
        date: "",
        time: "AM",
        notes: "",
        testdrive_type: "Standard",
        consent: {
            user: false
        },
        response_code: "",
        campaign_response_code: "",
        campaign_code: "",
        crm_response_source: "",
        is_dealer: (query === null || query === void 0 ? void 0 : query.source) === "dealer" || (query === null || query === void 0 ? void 0 : query.source) === "centre",
        dealer: 0,
        dealer_name: "",
        configID: configID ? "tme.one/".concat(configID) : "",
        is_lexus: brand === "lexus",
        enhanced_testdrive: false,
        enhanced_vehicle: {
            id: "",
            label: ""
        },
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
        utm_content: "",
        utm_term: "",
        utm_placement: "",
        utm_id: ""
    };
    const methods = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schemas/* TestDriveSchema */.m4),
        defaultValues: initialValues,
        mode: "onTouched"
    });
    const handleSetDealer = (dealerObj)=>{
        methods.setValue("dealer", dealerObj.id);
        methods.setValue("dealer_name", dealerObj.name);
        step(3, true);
        setSelectedDealer(dealerObj);
    };
    const isEnhancedTestDriveSelected = methods.watch("enhanced_testdrive");
    (0,react.useEffect)(()=>{
        let params = routerQuery;
        if (isEnhancedTestDriveSelected) {
            params = {
                ...routerQuery,
                ev_enhance: methods.getValues("enhanced_vehicle.id")
            };
        } else {
            delete params.ev_enhance;
        }
        push({
            query: {
                ...params
            }
        }, undefined, {
            shallow: true
        });
    }, [
        isEnhancedTestDriveSelected
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        if ((query === null || query === void 0 ? void 0 : (ref = query.type) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "48hr") {
            methods.setValue("testdrive_type", "FortyEightHr");
        }
        if ((query === null || query === void 0 ? void 0 : (ref1 = query.featured) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "motability") {
            methods.setValue("testdrive_type", "Motability TD");
        }
        if ((query === null || query === void 0 ? void 0 : (ref2 = query.featured) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "fleet") {
            methods.setValue("testdrive_type", "Fleet TD");
        }
        if (query === null || query === void 0 ? void 0 : query.utm_source) {
            methods.setValue("utm_source", query === null || query === void 0 ? void 0 : query.utm_source);
        }
        if (query === null || query === void 0 ? void 0 : query.utm_medium) {
            methods.setValue("utm_medium", query === null || query === void 0 ? void 0 : query.utm_medium);
        }
        if (query === null || query === void 0 ? void 0 : query.utm_campaign) {
            methods.setValue("utm_campaign", query === null || query === void 0 ? void 0 : query.utm_campaign);
        }
        if (query === null || query === void 0 ? void 0 : query.utm_content) {
            methods.setValue("utm_content", query === null || query === void 0 ? void 0 : query.utm_content);
        }
        if (query === null || query === void 0 ? void 0 : query.utm_term) {
            methods.setValue("utm_term", query === null || query === void 0 ? void 0 : query.utm_term);
        }
        if (query === null || query === void 0 ? void 0 : query.utm_placement) {
            methods.setValue("utm_placement", query === null || query === void 0 ? void 0 : query.utm_placement);
        }
        if (query === null || query === void 0 ? void 0 : query.utm_id) {
            methods.setValue("utm_id", query === null || query === void 0 ? void 0 : query.utm_id);
        }
    }, [
        query
    ]);
    (0,react.useEffect)(()=>{
        if (campaign === null || campaign === void 0 ? void 0 : campaign.campaign) {
            methods.setValue("campaign_code", campaign.campaign);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.media) {
            const code = methods.getValues("campaign_code");
            methods.setValue("campaign_code", code + campaign.media);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.testDrive) {
            methods.setValue("campaign_response_code", campaign.testDrive);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        campaign
    ]);
    (0,react.useEffect)(()=>{
        if (model) {
            if (brand === "lexus") {
                var ref;
                methods.setValue("response_code", model === null || model === void 0 ? void 0 : (ref = model.responsecodes) === null || ref === void 0 ? void 0 : ref.test_drive);
            }
            methods.setValue("model", model.d4t4.id);
            setFormData((state)=>{
                var ref, ref1, ref2, ref3, ref4;
                return {
                    ...state,
                    modelImage: (0,helpers/* getModelImage */.gU)(brand, model === null || model === void 0 ? void 0 : (ref = model.image) === null || ref === void 0 ? void 0 : ref.id, model === null || model === void 0 ? void 0 : (ref1 = model.image) === null || ref1 === void 0 ? void 0 : ref1.grade, model === null || model === void 0 ? void 0 : (ref2 = model.image) === null || ref2 === void 0 ? void 0 : ref2.color, "webp", model === null || model === void 0 ? void 0 : (ref3 = model.image) === null || ref3 === void 0 ? void 0 : ref3.fallback),
                    modelName: model.name,
                    fuel: model === null || model === void 0 ? void 0 : (ref4 = model.filters) === null || ref4 === void 0 ? void 0 : ref4.fuel[0]
                };
            });
            step(dealer ? 3 : 2, false);
        }
    }, [
        model
    ]);
    (0,react.useEffect)(()=>{
        if (dealer) {
            var ref, ref1;
            methods.setValue("is_dealer", true);
            methods.setValue("testdrive_type", "TwentyFourHr");
            methods.setValue("dealer", (dealer === null || dealer === void 0 ? void 0 : (ref = dealer.applications) === null || ref === void 0 ? void 0 : (ref1 = ref.NMSC) === null || ref1 === void 0 ? void 0 : ref1.externalID) ? dealer.applications.NMSC.externalID : "");
            methods.setValue("dealer_name", dealer.name);
            setSelectedDealer(dealer);
            step(model ? 3 : 1, false);
        }
    }, [
        dealer
    ]);
    const VehicleStep = ()=>formData.modelName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative ".concat(brand === "lexus" ? " uppercase" : ""),
            "data-gt-name": "componentevent",
            "data-gt-componentname": "test-drive",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "flex hover:underline",
                        onClick: ()=>{
                            step(1, true);
                            expandDetails(false);
                            expandVehicle(false);
                            methods.setValue("dealer", "");
                            methods.setValue("dealer_name", "");
                            setSelectedDealer({});
                            setFormData((state)=>{
                                return {
                                    ...state,
                                    modelImage: "",
                                    modelName: "",
                                    fuel: null,
                                    dealerID: "",
                                    dealerName: "",
                                    dealerDistance: "",
                                    address: ""
                                };
                            });
                            setSubmitResponse("");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-baseline md:flex-row md:space-x-2 md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "font-medium ".concat(brand === "lexus" ? " uppercase" : ""),
                                    children: [
                                        "1. ",
                                        brand === "lexus" ? "Car" : "Vehicle"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-tiny",
                                    children: "Change"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "md:flex text-tiny hidden mt-1",
                    "data-gt-action": "nav-".concat(isVehicleExpanded ? "open" : "close", "-dropdown"),
                    "data-gt-label": "vehicle",
                    onClick: ()=>{
                        expandVehicle((state)=>!state);
                        expandDealer(false);
                        expandDetails(false);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: formData.modelName
                        }),
                        formData.label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "ml-1",
                            children: [
                                " ",
                                formData.label
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-1 mt-1",
                            children: isVehicleExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "size-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "size-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                })
                            })
                        })
                    ]
                }),
                isVehicleExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute top-[70px] p-[15px] shadow-md z-10 w-[300px] bg-white",
                    "data-gt-componentgroup": "forms",
                    "data-gt-name": "componentevent",
                    "data-gt-componentname": "test-drive",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-medium",
                                            children: formData.modelName
                                        }),
                                        formData.fuel !== undefined && formData.fuel.toLowerCase() !== "petrol" && formData.fuel.toLowerCase() !== "diesel" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat(brand === "toyota" ? "font-medium text-blue" : "", " uppercase"),
                                            children: formData.fuel
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: ()=>{
                                        expandVehicle((state)=>!state);
                                        expandDealer(false);
                                        expandDetails(false);
                                    },
                                    "data-gt-action": "nav-close-dropdown",
                                    "data-gt-label": "vehicle",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "size-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full font-medium mt-4",
                            src: formData.modelImage,
                            alt: formData.modelName
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "font-semibold",
            children: [
                "1. ",
                brand === "lexus" ? "Car" : "Vehicle"
            ]
        });
    const DealerStep = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return selectedDealer.name ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative ".concat(brand === "lexus" ? " uppercase" : ""),
            "data-gt-name": "componentevent",
            "data-gt-componentname": "test-drive",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "flex hover:underline",
                        onClick: ()=>{
                            step(2, true);
                            expandDealer(false);
                            expandDetails(false);
                            expandVehicle(false);
                            methods.setValue("dealer", "");
                            methods.setValue("dealer_name", "");
                            setSelectedDealer({});
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-baseline md:flex-row md:space-x-2 md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "font-medium ".concat(brand === "lexus" ? " uppercase" : ""),
                                    children: [
                                        "2. ",
                                        brand === "lexus" ? "Centre" : "Dealer"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-tiny",
                                    children: "Change"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "md:flex text-tiny hidden mt-1",
                    onClick: ()=>{
                        expandDealer((state)=>!state);
                        expandVehicle(false);
                        expandDetails(false);
                    },
                    "data-gt-action": "nav-".concat(isDealerExpanded ? "open" : "close", "-dropdown"),
                    "data-gt-label": "dealer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "break-all w-full",
                            children: [
                                " ",
                                selectedDealer === null || selectedDealer === void 0 ? void 0 : selectedDealer.name,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-1 mt-1",
                            children: isDealerExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "size-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "size-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                })
                            })
                        })
                    ]
                }),
                isDealerExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute top-[70px] p-[15px] shadow-md z-10 w-[300px] bg-white",
                    "data-gt-componentgroup": "forms",
                    "data-gt-name": "componentevent",
                    "data-gt-componentname": "test-drive",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-tiny lowercase",
                                        children: selectedDealer.distance && "".concat((selectedDealer.distance * 0.62137119).toFixed(2), " miles")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: ()=>{
                                        expandDealer((state)=>!state);
                                        expandVehicle(false);
                                        expandDetails(false);
                                    },
                                    "data-gt-action": "nav-close-dropdown",
                                    "data-gt-label": "dealer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "size-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                })
                            ]
                        }),
                        (selectedDealer === null || selectedDealer === void 0 ? void 0 : selectedDealer.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-[10px] font-medium",
                            children: selectedDealer === null || selectedDealer === void 0 ? void 0 : selectedDealer.name
                        }),
                        (selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref = selectedDealer.address) === null || ref === void 0 ? void 0 : ref.address) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "normal-case",
                            children: [
                                " ",
                                selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref1 = selectedDealer.address) === null || ref1 === void 0 ? void 0 : ref1.address
                            ]
                        }),
                        (selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref2 = selectedDealer.address) === null || ref2 === void 0 ? void 0 : ref2.address1) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "normal-case",
                            children: [
                                " ",
                                selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref3 = selectedDealer.address) === null || ref3 === void 0 ? void 0 : ref3.address1
                            ]
                        }),
                        (selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref4 = selectedDealer.address) === null || ref4 === void 0 ? void 0 : ref4.city) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "normal-case",
                            children: [
                                " ",
                                selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref5 = selectedDealer.address) === null || ref5 === void 0 ? void 0 : ref5.city
                            ]
                        }),
                        (selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref6 = selectedDealer.address) === null || ref6 === void 0 ? void 0 : ref6.zip) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "normal-case",
                            children: [
                                " ",
                                selectedDealer === null || selectedDealer === void 0 ? void 0 : (ref7 = selectedDealer.address) === null || ref7 === void 0 ? void 0 : ref7.zip
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(formStep === 2 ? "font-semibold" : "font-medium"),
                children: [
                    "2. ",
                    brand === "lexus" ? "Centre" : "Dealer"
                ]
            })
        });
    };
    const DetailsStep = ()=>formData.first_name ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative ".concat(brand === "lexus" ? " uppercase" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "flex hover:underline",
                        onClick: ()=>{
                            step(4, true);
                            expandDealer(false);
                            expandDetails(false);
                            expandVehicle(false);
                            setFormData((state)=>{
                                return {
                                    ...state,
                                    first_name: "",
                                    last_name: "",
                                    email: "",
                                    phone: ""
                                };
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-baseline md:flex-row md:space-x-2 md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-medium ".concat(brand === "lexus" ? " uppercase" : ""),
                                    children: "3. Details"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-tiny",
                                    children: "Change"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "md:flex text-[13px] mt-[10px] leading-[10px] invisible lg:visible",
                    onClick: ()=>{
                        expandDetails((state)=>!state);
                        expandDealer(false);
                        expandVehicle(false);
                    },
                    "data-gt-action": "nav-".concat(isDealerExpanded ? "open" : "close", "-dropdown"),
                    "data-gt-label": "details",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "".concat(formData.first_name, " "),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-1 mt-1",
                            children: isDetailsExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "size-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "size-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                })
                            })
                        })
                    ]
                }),
                isDetailsExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute top-[70px] p-[15px] shadow-md z-10 w-[300px] bg-white",
                    "data-gt-componentgroup": "forms",
                    "data-gt-name": "componentevent",
                    "data-gt-componentname": "test-drive",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: "".concat(formData.first_name, " ").concat(formData.last_name)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: ()=>{
                                        expandDetails((state)=>!state);
                                        expandDealer(false);
                                        expandVehicle(false);
                                    },
                                    "data-gt-action": "nav-close-dropdown",
                                    "data-gt-label": "details",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "size-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                " ",
                                "".concat(formData.email, " ")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                " ",
                                "".concat(formData.phone, " ")
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(formStep === 3 ? "font-semibold" : "font-medium"),
                children: "3. Details"
            })
        });
    const onSubmit = async (data)=>{
        setSubmitResponse("");
        const formatData = data;
        if (data.enhanced_testdrive) {
            formatData.notes = "Customer would like to enhance their visit and test drive the ".concat(data.enhanced_vehicle.label);
        }
        await (0,axios/* default */.ZP)({
            method: "post",
            url: "".concat("https://api.toyota.co.uk/forms/api", "/test-drive"),
            headers: {
                "Content-Type": "application/json"
            },
            data: formatData
        }).then(()=>{
            (0,helpers_tracking/* formEvent */.Be)({
                conversion: 1,
                name: tracking.form,
                step: "form-submit",
                variant: "",
                page: tracking.page
            });
            (0,helpers/* closeOverlay */.Km)(content.confirmation.title, content.confirmation.copy, setSubmitResponse);
        }).catch(()=>{
            (0,helpers_tracking/* formEvent */.Be)({
                conversion: 0,
                name: tracking.form,
                step: "form-error",
                variant: "",
                page: tracking.page
            });
            setSubmitResponse(constants/* ERROR_MESSAGE */.c9);
            throw new Error(constants/* ERROR_MESSAGE */.c9);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Nav */.JL, {
                title: content.title,
                logoType: content === null || content === void 0 ? void 0 : content.logotype,
                customLogo: content === null || content === void 0 ? void 0 : content.customlogo,
                steps: [
                    VehicleStep(),
                    DealerStep(),
                    DetailsStep()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* FormWrapper */.n, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* FormStep */.p, {
                    title: content.car.title,
                    subtitle: "<p> If you're a fleet manager or small business owner, <a href='/fleet/callback' rel='noopener noreferrer' data-gt-name='link' data-gt-action=`callback-click-link` data-gt-label='callback-link' target='_blank'>click here</a> to request a demo.</p>",
                    step: formStep,
                    active: formStep === 1,
                    user: user,
                    tracking: {
                        conversion: 0,
                        name: tracking.form,
                        step: "select-model",
                        variant: tracking.variant,
                        page: tracking.page
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* ModelGrid */.fZ, {
                        models: models,
                        showFilter: content.car.filter,
                        setModel: (selectedModel)=>{
                            if (brand === "lexus") {
                                var ref;
                                methods.setValue("response_code", selectedModel === null || selectedModel === void 0 ? void 0 : (ref = selectedModel.responsecodes) === null || ref === void 0 ? void 0 : ref.test_drive);
                            }
                            methods.resetField("enhanced_testdrive");
                            if (brand === "toyota" && selectedModel.d4t4.id === "All New RAV4 Hybrid") {
                                methods.setValue("enhanced_vehicle", {
                                    id: "rav4PluginHybrid",
                                    label: "RAV4 Plug-in Hybrid"
                                });
                            }
                            if (brand === "toyota" && selectedModel.d4t4.id === "RAV4 PHEV") {
                                methods.setValue("enhanced_vehicle", {
                                    id: "bx4x",
                                    label: "All-Electric bZ4X"
                                });
                            }
                            if (brand === "lexus" && selectedModel.d4t4.id.includes("NX")) {
                                methods.setValue("enhanced_vehicle", {
                                    id: "rz",
                                    label: "All-Electric RZ"
                                });
                            }
                            if (brand === "lexus" && selectedModel.d4t4.id.includes("RX")) {
                                methods.setValue("enhanced_vehicle", {
                                    id: "rz",
                                    label: "All-Electric RZ"
                                });
                            }
                            methods.setValue("model", selectedModel.d4t4.id);
                            setTimeout(()=>{
                                window.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: "smooth"
                                });
                            }, 100);
                            if (methods.getValues("dealer")) {
                                step(3, true);
                            } else {
                                step(2, true);
                            }
                            setFormData((state)=>{
                                var ref, ref1, ref2, ref3, ref4;
                                return {
                                    ...state,
                                    modelImage: (0,helpers/* getModelImage */.gU)(brand, selectedModel === null || selectedModel === void 0 ? void 0 : (ref = selectedModel.image) === null || ref === void 0 ? void 0 : ref.id, selectedModel === null || selectedModel === void 0 ? void 0 : (ref1 = selectedModel.image) === null || ref1 === void 0 ? void 0 : ref1.grade, selectedModel === null || selectedModel === void 0 ? void 0 : (ref2 = selectedModel.image) === null || ref2 === void 0 ? void 0 : ref2.color, "webp", selectedModel === null || selectedModel === void 0 ? void 0 : (ref3 = selectedModel.image) === null || ref3 === void 0 ? void 0 : ref3.fallback),
                                    modelName: selectedModel.name,
                                    fuel: (selectedModel === null || selectedModel === void 0 ? void 0 : (ref4 = selectedModel.filters) === null || ref4 === void 0 ? void 0 : ref4.fuel[0]) || undefined
                                };
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* FormStep */.p, {
                step: formStep,
                active: formStep === 2,
                user: user,
                noContainer: true,
                tracking: {
                    conversion: 0,
                    name: tracking.form,
                    step: "select-dealer-get-location",
                    variant: tracking.variant,
                    page: tracking.page
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative z-[1]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* DealerFinder */.xd, {
                        setDealer: handleSetDealer
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* FormWrapper */.n, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* FormStep */.p, {
                    title: content.details.title,
                    step: formStep,
                    active: formStep === 3,
                    user: user,
                    tracking: {
                        conversion: 0,
                        name: tracking.form,
                        step: "contact-details",
                        variant: tracking.variant,
                        page: tracking.page
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, {
                        ...methods,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: methods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* AuthFill */.Pl, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* FirstName */.SW, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* LastName */.uQ, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Email */.GT, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Tel */.ki, {
                                    optional: true,
                                    helper: "Leave your phone number if you would like to discuss your test drive over the phone."
                                }),
                                brand === "lexus" && /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Date */.Ej, {
                                    showAmPm: true,
                                    helper: "Let us know if you have a preferred date or time and we'll do our best to arrange your booking for this time."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Comments */.HW, {
                                    label: "Additional Comments",
                                    helper: "Let us know if you have any specific requirements.",
                                    characterLimit: 255
                                }),
                                methods.getValues("enhanced_vehicle.id") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mt-8 mb-4 md:mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pt-5 pb-6 px-6 border-2 border-blue bg-primary md:col-span-2 lg:col-span-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col-reverse md:flex-row items-end md:items-center gap-4 mb-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                        className: "font-semibold",
                                                        children: [
                                                            "Would you like to enhance your visit and test drive the",
                                                            " ",
                                                            methods.getValues("enhanced_vehicle.label"),
                                                            "?"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ev, {
                                                        className: "text-blue shrink-0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(baseInputs/* CheckboxInput */.I0, {
                                                name: "enhanced_testdrive",
                                                label: "Yes, I would like to test drive the ".concat(methods.getValues("enhanced_vehicle.label"))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* MarketingConsent */.nb, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fields/* Button */.zx, {
                                    submitResponse: submitResponse,
                                    children: content.details.submit
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
TestDrive.whyDidYouRender = true;
var __N_SSP = true;
/* harmony default export */ var test_drive = (TestDrive);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7409,1850,9595,9516,388,4817,9774,2888,179], function() { return __webpack_exec__(62328); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);